.tableWrapper {
    position: relative;
    width: 100%;
    overflow-x: auto;

    :global(.tbNoBorder) {
        border: none;

        td,
        th {
            border: none;
        }
    }
}

.tableOuter {
    border: 1px solid var(--mantine-color-gneis-1);
    border-radius: var(--mantine-radius-sm);
    overflow: hidden;
}

.tableToolbar {
    display: flex;
    align-items: center;
    padding: 0.25rem 0.5rem;
    background-color: var(--mantine-color-gneis-0);
    border-bottom: 1px solid var(--mantine-color-gneis-1);
}

.fullscreenButton {
}

.modalTable {
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: var(--article-font-body);
    font-size: 0.875rem;
    line-height: 1.5;
    color: var(--article-text);

    th,
    td {
        padding: 0.5rem 0.75rem;
        text-align: left;
        border-bottom: 1px solid var(--article-border);
        vertical-align: top;
    }

    th {
        font-weight: 700;
        font-family: var(--article-font-body);
        color: var(--article-heading);
        background-color: var(--article-bg-subtle);
        font-size: 0.8125rem;
        letter-spacing: 0.01em;
    }

    tbody tr:nth-child(even) {
        background-color: var(--article-border-subtle);
    }

    tbody tr:last-child td,
    tbody tr:last-child th {
        border-bottom: none;
    }

    &:global(.tbNoBorder) {
        border: none;

        td,
        th {
            border: none;
        }
    }
}
